import { lazy, Suspense } from "react";
import { Link, Route, Routes } from "react-router";
import { Button, Spinner } from "@rekati/ui";
import { useI18n } from "../content/i18n";
import { EventPage } from "../features/event/EventPage";
import { SiteFooter } from "../features/shell/SiteFooter";
import { SiteHeader } from "../features/shell/SiteHeader";

// The event page is the landing; the flow and the account load when opened.
const RegisterPage = lazy(() =>
  import("../features/registration/RegisterPage").then((m) => ({ default: m.RegisterPage })),
);
const ReturningPage = lazy(() =>
  import("../features/returning/ReturningPage").then((m) => ({ default: m.ReturningPage })),
);
const WalkInPage = lazy(() =>
  import("../features/walk-in/WalkInPage").then((m) => ({ default: m.WalkInPage })),
);
const SurveyPage = lazy(() =>
  import("../features/survey/SurveyPage").then((m) => ({ default: m.SurveyPage })),
);

/**
 * `/` the event · `/register` the question flow · `/rsvp` the returning
 * attendee (the path every backend email links to, FRONTEND_BASE_URL/rsvp) ·
 * `/survey` the on-the-day survey and its merchandise QR · `/walk-in` the
 * public walk-in form.
 */
export function App() {
  const { t } = useI18n();
  return (
    <>
      <a
        href="#main"
        className="sr-only z-50 rounded-md bg-volt px-4 py-2 font-medium text-volt-foreground focus:not-sr-only focus:fixed focus:top-3 focus:left-3"
      >
        {t("meta.skip")}
      </a>
      <Suspense
        fallback={
          <div className="grid min-h-dvh place-items-center text-foreground">
            <Spinner />
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<EventPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/rsvp" element={<ReturningPage />} />
          <Route path="/survey" element={<SurveyPage />} />
          <Route path="/walk-in" element={<WalkInPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
}
function NotFound() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-dvh flex-col">
      <SiteHeader />
      <main id="main" className="flex flex-1 items-center px-5 sm:px-12">
        <div className="mx-auto grid max-w-xl gap-5">
          <p className="w-fit rounded-sm bg-volt px-1.5 py-0.5 font-mono text-sm text-volt-foreground">404</p>
          <h1 className="text-4xl font-semibold tracking-tight">{t("notFound.title")}</h1>
          <p className="text-muted-foreground">{t("notFound.body")}</p>
          <Button asChild variant="volt" size="lg" className="w-fit">
            <Link to="/">{t("notFound.home")}</Link>
          </Button>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
